/*
  Toggle logic for the hardcoded FAQ accordion (.acc-wrap) in main-product.liquid.
  Extracted from an inline <script> so it loads deferred and cached instead of
  running synchronously during HTML parse.
*/
(function () {
  function initAccordions() {
    document.querySelectorAll('.acc-wrap').forEach(function (wrap) {
      wrap.querySelectorAll('.acc-header').forEach(function (h) {
        h.addEventListener('click', function () {
          var item = h.parentElement;
          var isActive = item.classList.contains('active');
          wrap.querySelectorAll('.acc-item').forEach(function (i) {
            i.classList.remove('active');
          });
          if (!isActive) item.classList.add('active');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }
})();
